import { gql } from "@apollo/client";

import timelineEntryFragment from "./timeline-entry-fragment";

export default gql`
  query getComplianceProgramTimeline($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      timeline {
        ...TimelineEntry
      }
    }
  }
  ${timelineEntryFragment}
`;
